import { defineComponent as o, openBlock as t, createElementBlock as s, normalizeClass as d, renderSlot as l } from "vue";
import { _ as r } from "../_plugin-vue_export-helper-CHgC5LLL.js";
import '../Toast.css';const n = ["id"], i = /* @__PURE__ */ o({
  __name: "Toast",
  props: {
    open: { type: Boolean, default: !1 },
    id: { default: "" },
    variant: { default: "default" },
    placement: { default: "top-left" },
    size: { default: "small" },
    border: { type: Boolean, default: !0 },
    shadow: { type: Boolean, default: !0 },
    classes: { default: () => ({}) }
  },
  setup(p) {
    return (e, f) => {
      var a;
      return t(), s("div", {
        id: e.id,
        class: d([
          "toast-container",
          `toast-${e.placement}`,
          `toast-size-${e.size}`,
          `toast-${e.variant}`,
          { "!hidden": !e.open, border: e.border, "shadow-sm": e.shadow },
          (a = e.classes) == null ? void 0 : a.container
        ]),
        role: "alert"
      }, [
        l(e.$slots, "default", {}, void 0, !0)
      ], 10, n);
    };
  }
}), c = /* @__PURE__ */ r(i, [["__scopeId", "data-v-563d9cd0"]]);
export {
  c as default
};
//# sourceMappingURL=Toast.esm.js.map
